import React from "react";
import i18n from "../../../../constants/i18n";
import {
  DEVELOPER_GENERATED_TABLES_SUMMARY_HEADERS,
  DEVELOPER_SUB_TABS_ACCESS_SUMMARY_HEADERS
} from "../../../../constants/table-custom-headers/Developers";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getAdminUsageStore from "../../../../stores/developer-store/admin-usage";

const AdminUsageData = withLiteObserverAndTheme(() => {
  const adminSubTabAccessData =
    getAdminUsageStore().adminSubTabAccessData.get();
  const adminGeneratedTablesData =
    getAdminUsageStore().adminGeneratedTablesData.get();
  return (
    <React.Fragment>
      <Et3Table
        columns={DEVELOPER_SUB_TABS_ACCESS_SUMMARY_HEADERS}
        rows={adminSubTabAccessData}
        title={i18n.get("SUB_TAB_ACCESS_SUMMARY")}
        shouldBeFlagged={false}
        titleKey={"SUB_TAB_ACCESS_SUMMARY"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DEVELOPER_GENERATED_TABLES_SUMMARY_HEADERS}
        rows={adminGeneratedTablesData}
        title={i18n.get("GENERATED_TABLES_SUMMARY")}
        shouldBeFlagged={false}
        titleKey={"GENERATED_TABLES_SUMMARY"}
      />
    </React.Fragment>
  );
});

export default AdminUsageData;
